// extracted by css-extract-rspack-plugin
export default {"socialLink":"_3a6d4d68","socialTooltip":"_fbc8485d","socialIcon":"_9c62ec83","discordInput":"_65422e41","focus-visible":"_6024ef9c","focusVisible":"_6024ef9c"};